module.exports = __webpack_public_path__ + "img/ggA_Spalt.066b4989.png";